import './styles';
import './styles/views.login.scss';

$(document).ready(function () {
    const ui = {
        form: $('form'),
        loginActionsEl: $('#login-actions'),
        returnUrl: $('#return-url'),
        loginLookupBtn: $('#login-lookup-btn'),
        emailInput: $('#email-input'),
        passwordInput: $('#password-input'),
        loginBtn: $('#login-btn'),
        continueToLoginBtn: $('#continueToLoginBtn')
    };

    // On first load enable the continue button if the email field is populated (autocomplete)
    if (ui.emailInput.length > 0 && ui.emailInput.val().length > 0) {
        ui.loginLookupBtn.removeAttr('disabled');
    }

    // This function disables/enables the continue button depending on the username input value
    function checkBtnTargetState() {
        if (ui.emailInput.val().length > 0) {
            ui.loginLookupBtn.removeAttr('disabled');
        } else {
            ui.loginLookupBtn.prop('disabled', 'disabled');
        }
    }

    // This function generates the redirect Url if SAML is enabled
    function getRedirectUrl(path) {
        // Set base redirect url as path
        var redirectUrl = path;

        // Append returnUrl as query parameter if requested
        var returnUrl = ui.returnUrl.data('returnurl');
        if (returnUrl) {
            if (redirectUrl.includes('?')) {
                return redirectUrl + '&returnUrl=' + encodeURIComponent(returnUrl);
            }
            return redirectUrl + '?returnUrl=' + encodeURIComponent(returnUrl);
        }
        return redirectUrl;
    }

    // check if the btn should be enabled/disabled when the input changes
    if (ui.emailInput.length > 0) {
        ui.emailInput.on('change keyup', (e) => {
            e.preventDefault();
            if (e.which === 13) {
                ui.loginLookupBtn.click();
            }
            return checkBtnTargetState();
        });
    }

    // also check if it needs to be enabled/disabled every 0.5 secs to catch auto-completes etc.
    if (ui.emailInput.length > 0 && ui.loginLookupBtn.length > 0) {
        setInterval(checkBtnTargetState, 500);
    }

    // This click handler makes the AJAX request to fetch the user's SAML settings
    if (ui.loginLookupBtn.length > 0) {
        ui.loginLookupBtn.on('click', function (e) {

            // Do not continue if no email is specified
            if (!ui.emailInput.val()) {
                return;
            }

            // Replace the continue button content with a loading spinner (see ./styles.js for this jquery extenstion function)
            ui.loginLookupBtn.btnProgressStart();

            // Send external login request
            $.ajax({
                'type': 'GET',
                'url': `/api/users/${ui.emailInput.val()}/samlsettings`,
                'success': function (response) {
                    if (response.IsSaml || response.isSaml) {
                        // IsSaml is true so we can redirect to the ExternalLoginRequest endpoint
                        document.location = getRedirectUrl('ExternalLoginRequest?email=' + ui.emailInput.val());
                    } else {
                        // Tenancy isn't a SAML one so show local login UI and focus the password input
                        ui.loginActionsEl.show();
                        ui.loginBtn.removeAttr('disabled');
                        ui.loginLookupBtn.hide();
                        ui.passwordInput.focus();
                    }
                },
                'error': function () {
                    // Error function would be hit if the user/tenancy doesn't exist... we don't want to give away this info so act like it's just a local account!
                    ui.loginActionsEl.show();
                    ui.loginLookupBtn.hide();
                    ui.passwordInput.focus();
                    ui.loginBtn.removeAttr('disabled');
                }
            });
        });
    }

    // Click handler to redirect to login page
    if (ui.continueToLoginBtn.length > 0) {
        ui.continueToLoginBtn.on('click', function (e) {
            window.location.href = getRedirectUrl('/Account/Login');
        });
    }
});